import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { PanelTitle, SimpleDataList } from 'ui';
import { getHomeSubscriptions } from 'modules/shop/selectors/shopSelectors';

export const HomeSubscriptions = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const subscriptions = useSelector(getHomeSubscriptions);

  const handleItemClick = ({ id }) => {
    navigate(`/subscriptions?productId=${id}`);
  };

  return (
    <>
      <PanelTitle>{t('My subscriptions')}</PanelTitle>
      <SimpleDataList
        data={subscriptions.data}
        loading={subscriptions.isPending}
        onItemClick={handleItemClick}
        emptyText={t('There are no subscriptions yet.')}
      />
    </>
  );
};
